export enum AssigneeTypesEnum {
  CLASSGROUP = 'classgroup',
  GROUP = 'group',
  STUDENT = 'student',
}
